<template>
  <tbody class="border-bottom">
    <tr class="border--hidden">
      <td class="half-width">
        <span v-if="preExistingProgram" class="has-text-weight-bold">{{ convertProrgamCode }}</span>

        <es-select
          v-else
          v-on:update:values="programs = $event"
          valueTpl="${program.description}"
          :setValues="availablePrograms"
          keyValue="programCode"
        />
      </td>
      <td class="one-fourth-width">
        <span v-if="!isEditing">
          {{ getStartDate }}
        </span>

        <input
          v-else
          class="input"
          :class="{ 'is-danger': this.hasErrorStartDate }"
          v-model="startDate"
          type="date"
        />
      </td>
      <td class="one-fourth-width">
        <span v-if="!isEditing">
          {{ getEndDate }}
        </span>

        <input
          v-else
          class="input"
          :class="{ 'is-danger': this.hasErrorEndDate }"
          v-model="endDate"
          type="date"
        />
      </td>
      <td style="padding: 0">
        <a v-if="isEditing && match.isNewMatch"
          @click.prevent="deleteNewRow()">
          <font-awesome-icon :icon="['fal', 'times']"
          class="fa-lg" />
        </a>
      </td>
    </tr>
    <tr class="row-warnings border--hidden" v-if="hasErrorProgramCode || hasErrorStartDate || hasErrorEndDate">
      <td>
        <p v-if="hasErrorProgramCode && hasErrors" class="invalid-feedback has-text-left">{{ programCodeMsg }}</p>
      </td>
      <td>
        <p v-if="hasErrorStartDate" class="invalid-feedback has-text-left">{{ startDateMsg }}</p>
      </td>
      <td>
        <p v-if="hasErrorEndDate" class="invalid-feedback has-text-left">{{ endDateMsg }}</p>
      </td>
    </tr>
    <tr>
      <td colspan="4"  >
        <div class="field is-horizontal text-area--margin-right">
          <div class="field-label is-flex flex-align--center" style="max-width: fit-content">
            <label class="label" style="font-weight: 400">Match Reason:</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input
                  v-if="!isEditing"
                  style="font-size: 12px"
                  type="text"
                  class="input"
                  :class="{ 'is-static': !isEditing }"
                  readonly
                  :value="match.matchReason"
                />
                <textarea
                  v-else
                  class="textarea"
                  type="textarea"
                  required
                  v-model="match.matchReason"
                  rows="2"
                  placeholder="Enter match reason"
                  style="flex-grow:1; margin-left: 12px;"
                  maxlength="255"
                />
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import moment from 'moment';
import EsSelect from '@/components/EsSelect.vue';
import DateUtils from '@/mixins/DateUtils';


library.add(faTimes);

export default {
  mixins: [DateUtils],
  props: [
    'isEditing',
    'match',
    'availablePrograms',
    'schoolStartDate',
    'schoolEndDate',
    'programTypes',
    'hasErrors',
  ],
  components: {
    EsSelect,
  },
  data() {
    return {
      // programType: null,
      endDate: null,
      endDateMsg: null,
      hasError: null,
      hasErrorEndDate: null,
      hasErrorProgramCode: null,
      hasErrorStartDate: null,
      matchCopy: null,
      programCodeMsg: null,
      programs: [],
      startDate: null,
      startDateMsg: null,
      valid: true,
    };
  },
  created() {
    if (this.match.studentProgram.exitDate) {
      this.endDate = this.match.studentProgram.exitDate;
    }
    if (this.match.studentProgram.entryDate) {
      this.startDate = this.match.studentProgram.entryDate;
    } else {
      // get set to today's date
    }
  },
  mounted() {
    this.checkForErrors();
  },
  watch: {
    endDate() {
      if (!this.endDate) {
        delete this.match.studentProgram.exitDate;
      } else {
        this.match.studentProgram.exitDate = this.endDate;
      }
      this.endDateWatcher();
      this.startDateWatcher();
    },
    // checking to see if there are any errors every time the match[] is updated.
    match: {
      handler() {
        this.checkForErrors();
      },
      deep: true,
    },
    startDate() {
      this.match.studentProgram.entryDate = this.startDate;
      this.endDateWatcher();
      this.startDateWatcher();
    },
    programs() {
      this.match.studentProgram.programCode = this.programs[0].programCode;
    },
  },
  computed: {
    convertProrgamCode() {
      const p = this.programTypes
        .find(program => this.match.studentProgram.programCode === program.code);
      if (p) return p.description;
      return null;
    },
    getEndDate() {
      if (this.endDate) {
        return moment(this.endDate).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
    getStartDate() {
      return moment(this.startDate).format('MM/DD/YYYY');
    },
    selectedProgramType() {
      const t = this.programTypes
        .find(program => program.programCode === this.match.studentProgram.programCode);
      if (t) return t.program.description;
      return null;
    },
    preExistingProgram() {
      if (this.match.studentProgram.programCode) {
        return true;
      }
      return false;
    },
  },
  methods: {
    checkForErrors() {
      if (!this.match.studentProgram.programCode || this.hasErrorStartDate || this.hasErrorEndDate) {
        this.hasError = true;
      } else {
        this.hasError = false;
      }

      if (!this.match.studentProgram.programCode) {
        this.programCodeMsg = 'Program Code is required.';
        this.hasErrorProgramCode = true;
      } else if (this.hasErrorProgramCode) {
        this.hasErrorProgramCode = false;
      }
    },
    deleteNewRow() {
      this.$emit('deleteNewProgram');
    },
    endDateWatcher() {
      if (this.isEditing || this.match.isNewMatch) {
        if (!this.endDate) {
          this.hasErrorEndDate = false;
          this.endDateMsg = null;
        } else if (this.endDate && this.endDate > moment(this.schoolEndDate).format('YYYY-MM-DD')) {
          this.endDateMsg = 'End Date is invalid.';
          this.hasErrorEndDate = true;
        } else if (this.endDate && !this.isValidDateFormat(this.endDate, 'YYYY-MM-DD')) {
          this.endDateMsg = 'End Date is invalid.';
          this.hasErrorEndDate = true;
        } else if (this.endDate && this.endDate < this.startDate) {
          this.endDateMsg = 'End Date cannot be earlier than Start Date.';
          this.hasErrorEndDate = true;
        } else if (this.hasErrorEndDate) {
          this.hasErrorEndDate = false;
          this.endDateMsg = null;
        }
      }
    },
    startDateWatcher() {
      if (this.isEditing || this.match.isNewMatch) {
        if (!this.startDate) {
          this.hasErrorStartDate = true;
          this.startDateMsg = 'Start Date is required.'
        } else if (this.startDate
          && (this.startDate < moment(this.schoolStartDate).format('YYYY-MM-DD')
          || this.startDate > moment(this.schoolEndDate).format('YYYY-MM-DD'))) {
          this.hasErrorStartDate = true;
          this.startDateMsg = 'Start Date is invalid.'
        } else if (this.startDate && !this.isValidDateFormat(this.startDate, 'YYYY-MM-DD')) {
          this.hasErrorStartDate = true;
          this.startDateMsg = 'Start Date is invalid.'
        } else if (this.hasErrorStartDate) {
          this.hasErrorStartDate = false;
          this.startDateMsg = null;
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .border--hidden
    border-bottom: hidden
  .row-warnings
    height: auto
    line-height: 0.5
  .fullwidth
    width: 100%
  .half-width
    width: 50%
  .one-fourth-width
    width: 25%
  .text-area--margin-right
    margin-right: 3.25rem
  .invalid-feedback
    font-style: italic
    color: #dc3545
    font-size: .7rem
    padding: .25rem 0 .25rem .15rem
</style>
